import { render, staticRenderFns } from "./PagamentosConfirmar.vue?vue&type=template&id=ecb47902&"
import script from "./PagamentosConfirmar.vue?vue&type=script&lang=js&"
export * from "./PagamentosConfirmar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports